import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_VERIFICAIONS_BANKING } from "..";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";

export const RouteBankingVerification: React.FC = () => {
  const history = useHistory();
  const queryFeatureFlags = useFeatureFlags();

  const modules = useMemo(
    (): OnboardingModule[] => [
      {
        type: "create_account",
        options: {
          accountTypes: ["Individual", "Business"],
          verificationLevel: "Banking",
          allowUSInternationalPerson:
            queryFeatureFlags.data?.internationalUsPerson
        },
        title: "Banking verification"
      }
    ],
    [queryFeatureFlags.data?.internationalUsPerson]
  );

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_VERIFICAIONS_BANKING}
      modules={modules}
      onSuccess={() => {
        history.push("/member");
      }}
    />
  );
};
